import React from 'react';

import EditProfile from './EditProfile';
import ApplicationProcess from './ApplicationProcess/ApplicationProcess';

import { Grid, Paper, MenuItem, Typography, Button } from '@mui/material';
import { Link, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../../../api';

const UserDashboard = ({ session, user }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const signOut = () => {
    supabase.auth.signOut();
    navigate('/signout', { replace: true });
  };

  return (
    <Grid container component='main' sx={{ mt: '4rem', justifyContent: 'space-between' }}>
      <Grid item xs={12} lg={4.5}>
        <Paper
          elevation={20}
          sx={{
            padding: { xs: '1rem', sm: '2rem' },
            mt: '2rem',
            textAlign: 'center',
          }}>
          {(user.membershipLevel === 'member' ||
            user.membershipLevel === 'member+mentor' ||
            user.membershipLevel === 'mentor') && (
            <Link to='editProfile' style={{ textDecoration: 'none' }}>
              <MenuItem
                key={1}
                divider='true'
                value={'Edit Profile'}
                sx={{ color: 'primary.main' }}
                selected={
                  user.membershipLevel === 'member' ||
                  user.membershipLevel === 'member+mentor' ||
                  user.membershipLevel === 'mentor'
                    ? location.pathname === '/dashboard/editProfile' || location.pathname === '/dashboard'
                    : location.pathname === '/dashboard/editProfile'
                }>
                Edit Profile
              </MenuItem>
            </Link>
          )}

          <a href='https://billing.stripe.com/p/login/fZe28ifrwalNdi05kk' target='_blank' rel='noreferrer'>
            <MenuItem key={1} divider='true' value={'Payment Dashboard'} sx={{ color: 'primary.main' }}>
              Payment Dashboard
            </MenuItem>
          </a>

          <Link to='/setPassword' style={{ textDecoration: 'none' }}>
            <MenuItem key={1} divider='true' value={'Set Password'} sx={{ color: 'primary.main' }}>
              Change Password
            </MenuItem>
          </Link>

          <MenuItem key={2} value={'Log Out'} onClick={signOut}>
            Logout
          </MenuItem>
        </Paper>
        {user.membershipLevel === 'mentor' && (
          <Paper
            elevation={20}
            sx={{
              padding: '1rem',
              mt: '2rem',
              textAlign: 'left',
              bgcolor: 'primary.main',
              color: 'white',
            }}>
            <Typography>
              If you'd like to go beyond mentorship, and officially become a member of The 100 Club and get access to
              all the perks (ie. monthly masterminds, physical community, digital community, perks, etc.), apply below.
            </Typography>
            <a href='https://szuv34ek50v.typeform.com/to/GPAg2BTo'>
              <Button
                variant='outlined'
                sx={{
                  mt: '1rem',
                  backgroundColor: 'white',
                  '&:hover': { backgroundColor: 'white' },
                }}>
                Apply to become a member
              </Button>
            </a>
          </Paper>
        )}
        {user.membershipLevel !== 'member' &&
          user.membershipLevel !== 'member+mentor' &&
          user.membershipLevel !== 'mentor' && (
            <Paper
              elevation={20}
              sx={{
                padding: '1rem',
                mt: '2rem',
                textAlign: 'left',
                bgcolor: 'primary.main',
                color: 'white',
              }}>
              <Typography>
                Your account has been disabled as you are no longer a member of The 100 Club. Email us at
                hello@the100club.io if there any issues or if you would like to rejoin us!
              </Typography>
            </Paper>
          )}
        {!user.onboardingCompleted &&
          (user.membershipLevel === 'member' || user.membershipLevel === 'member+mentor') && (
            <Paper
              elevation={20}
              sx={{
                padding: '2rem',
                mt: '2rem',
                textAlign: 'left',
                bgcolor: 'primary.main',
                color: 'white',
              }}>
              <Typography>
                Welcome to The 100 Club! Before you access your account, please take a few mins to complete this
                onboarding process so that you know how to fully make use of our community.
              </Typography>
              <Link to={`/onboarding/${session.user.id}`} style={{ textDecoration: 'none' }}>
                <Button
                  variant='outlined'
                  sx={{
                    mt: '1rem',
                    backgroundColor: 'white',
                    '&:hover': { backgroundColor: 'white' },
                  }}>
                  Start onboarding
                </Button>
              </Link>
            </Paper>
          )}
      </Grid>

      <Grid item xs={12} lg={7} elevation={6} square>
        <Routes>
          <Route
            path='/'
            element={
              user.membershipLevel === 'member' ||
              user.membershipLevel === 'member+mentor' ||
              user.membershipLevel === 'mentor' ? (
                <EditProfile key={session.user.id} session={session} membershipLevel={user.membershipLevel} />
              ) : (
                ''
              )
            }
          />
          <Route
            path='editProfile'
            element={<EditProfile key={session.user.id} session={session} membershipLevel={user.membershipLevel} />}
          />
          <Route
            path='application'
            element={<ApplicationProcess session={session} membershipLevel={user.membershipLevel} />}
          />
        </Routes>
      </Grid>
    </Grid>
  );
};

export default UserDashboard;
